import * as React from 'react';

import EmptyCell from './EmptyCell';
import styles from './styles.module.scss';

interface Props {
	value: string | number;
	className?: string;
	bold?: boolean;
	emptyMessage?: string;
}

const TextCell: React.FC<Props> = ({ value, className, bold, emptyMessage }) => {

	if (!value) {
		return <EmptyCell className={className} message={emptyMessage ?? 'N/A'} />;
	}

	const classNames = [styles['text-cell']];
	if (className) {
		classNames.push(className);
	}

	if (bold) {
		classNames.push(styles['bold-content']);
	}

	if (typeof value === 'number') {
		return <span className={classNames.join(' ')}>{value}</span>;
	}

	// Split the value by newline characters and map them to <br /> elements
	const formattedValue = (value ?? '')?.split?.('\n')?.map((line, index) => (
		<React.Fragment key={index}>
			{line}
			<br />
		</React.Fragment>
	));

	return <span className={classNames.join(' ')}>{formattedValue}</span>;
};

export default TextCell;
